import classNames from 'classnames'
import { ButtonHTMLAttributes } from 'react'

// A <button> styled like a regular text link.
export const LinkButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    {...props}
    className={classNames(
      'appearance-none underline hover:text-primary-800 text-emphasis-extra disabled:opacity-30 disabled:cursor-not-allowed',
      props.className
    )}
  >
    {props.children}
  </button>
)
